/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_No_SubscriptionsInputs */

const en_admin_subscriptions_no_subscriptions = /** @type {(inputs: Admin_Subscriptions_No_SubscriptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No subscriptions yet`)
};

/**
* | output |
* | --- |
* | "No subscriptions yet" |
*
* @param {Admin_Subscriptions_No_SubscriptionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_no_subscriptions = /** @type {((inputs?: Admin_Subscriptions_No_SubscriptionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_No_SubscriptionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_subscriptions_no_subscriptions(inputs)
});
export { admin_subscriptions_no_subscriptions as "admin.subscriptions.no_subscriptions" }